import { SVG, SVGProps } from './svg'

export function IconTriangleOutlineUp(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M12.8 2.4 23 19.6c.1.3.1.6 0 .8l-.1.2c-.2.3-.4.4-.7.4H2a.7.7 0 0 1-.7-.4l-.1-.2a.8.8 0 0 1 0-.8L11.2 2.4c.1-.3.4-.4.7-.4h.3c.2 0 .5.1.6.4ZM12 5 3.8 19h16.4L12 5Z"
      />
    </SVG>
  )
}
